<template>
  <v-col class="my-4">
    <p class="input-label text-style dark--text mb-3">Filter by Buckets</p>
    <template v-if="!allBuckets">
      <v-row v-for="i in selectedBuckets" :key="i.idx" class="mt-2 mx-1">
        <v-col class="px-0 py-0 mb-2">
          <v-autocomplete
            v-model="i.name"
            :placeholder="bucketsLoading ? 'Loading buckets...' : 'Select a bucket'"
            :items="buckets"
            :menu-props="{ offsetY: true }"
            :filter="filter"
            class="select-field mr-2"
            :loading="bucketsLoading"
            :rules="[rules.required]"
          />
          <span v-if="error" class="error-time">Field is Required</span>
        </v-col>
        <v-text-field label="Prefix (Optional)" v-model="i.prefix" class="select-field mx-2" />
        <!-- <a class="material-icons dark--text d-flex flex-column justify-content-center" @click="handleBucketRemoved(i)"> clear</a> -->
      </v-row>
    </template>
    <v-checkbox v-model="allBuckets" hide-details class="shrink mr-2 my-0">
      <template v-slot:label>
        <p class="input-label text-style dark--text my-0">All buckets</p>
      </template>
    </v-checkbox>
    <!-- <v-btn class="link-btn" text @click="handleBucketAdded">+ Add bucket filter </v-btn> -->
  </v-col>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: ['error'],
  data () {
    return {
      allBuckets: false,
      selectedBuckets: [
        {
          idx: 1,
          name: '',
          prefix: ''
        }
      ],
      rules: {
        required: (v) => !!v || 'Field is Required'
      }
    }
  },
  computed: {
    ...mapGetters(['bucketsLoading', 'buckets'])
  },
  methods: {
    filter (item, queryText, itemText) {
      if (!this.selectedBuckets.map((bucket) => bucket.name).includes(item)) {
        return itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
      }
    },
    handleBucketAdded () {
      this.selectedBuckets.push({
        idx: (this.selectedBuckets?.[this.selectedBuckets.length - 1]?.idx || 0) + 1,
        name: '',
        prefix: ''
      })
    },
    handleBucketRemoved (bucket) {
      const index = this.selectedBuckets.map((i) => i.idx).indexOf(bucket.idx)
      if (index >= 0) {
        this.selectedBuckets.splice(index, 1)
      }
    }
  }
}
</script>
